import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { EventLogService, Actions } from '../services/eventLog';
import { SetMaterialsService } from '../services/set-materials.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';

@Component({
  selector: 'app-edit-deck-material',
  templateUrl: './edit-deck-material.component.html',
  styleUrls: ['./edit-deck-material.component.scss']
})
export class EditDeckMaterialComponent {

  selectedMaterialType;

  @Output() step1Editer = new EventEmitter();

  goBack (value) {
    this.step1Editer.emit({ name: value });
  }

  constructor(
    private eventLogSrvc: EventLogService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService,
    private setMaterialsService: SetMaterialsService
  ) { 
    this.selectedMaterialType = 'wood-redWood';
    dataForDisplayingMenuItemsService.startNewProj.subscribe(() => {
      this.selectedMaterialType = 'wood-redWood';
      this.setMaterialsService.setMaterial('wood-redWood');
    })
  }

  setMaterial(texture: string) {
    this.selectedMaterialType = texture;
    this.eventLogSrvc.dispatch(new Actions.ChangeMaterialAction(texture));
  }

  getMaterial() {
    return this.selectedMaterialType;
  }

}



// WEBPACK FOOTER //
// ./src/app/edit-deck-material/edit-deck-material.component.ts